import axios from "axios";
import endpoints from "../endpoint";

export const shouldShowNavbar = (location, user) => {
  const userRole = user?.role;
  return (
    (userRole === "student" && location.pathname.startsWith("/student")) ||
    (userRole === "student" && location.pathname.startsWith("/")) ||
    (userRole === "student" && location.pathname.startsWith("/profile"))
  );
};

export const getVideoUrl = (publicId) => {
  return `${endpoints.serverBaseUrl}api/live/${publicId}`;
};

export const getImageUrl = (publicId) => {
  return `${endpoints.serverBaseUrl}api/image/${publicId}`;
};

export const AvgRating = async (courseId) => {
  try {
    const response = await axios.get(
      `${endpoints.serverBaseUrl}api/review/rating/${courseId}`,
      {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching average rating:", error);
    return null;
  }
};
